import React from 'react'
import PropTypes from 'prop-types'
import CreatePageModal from './CreatePageModal'
import AlertContainer from 'react-alert'
import { Redirect } from 'react-router-dom'
import { createPage } from '../../api/pages'

class CreatePageModalContainer extends React.PureComponent {
  alertOptions = {
    offset: 14,
    position: 'top right',
    theme: 'dark',
    time: 5000,
    transition: 'scale'
  }

  constructor (props, context) {
    super(props, context)
    this.state = {}
  }

  createPage = async (pageTitle) => {
    // basic title frontend validation
    const title = pageTitle ? pageTitle.trim() : ''
    if (title === '') {
      this.msg.show('Please enter a page title', { type: 'error', time: 6000 })
      return
    }

    // build the page
    const page = {
      title: title,
      parentId: this.props.parentId && parseInt(this.props.parentId),
      sections: [{
        content: {
          document: {
            nodes: [{
              kind: 'block',
              type: 'paragraph',
              nodes: [{ kind: 'text', text: '' }]
            }]
          }
        }
      }]
    }

    // start save
    this.setState({isSaving: true})

    const _state = {
      isSaving: false,
      page: null
    }
    // do update
    try {
      const newPage = await createPage(page)
      console.info(`Created new page id:${newPage.id}`)
      _state.page = newPage
    } catch (error) {
      const errorMessage = error.data ? error.data.message : 'An error occurred'
      this.msg.show(errorMessage, { type: 'error', time: 6000 })
    }

    // finished
    this.setState(_state)
  }

  render () {
    // redirect to edit page after successful creation
    if (this.state.page && this.state.page.id) {
      return <Redirect to={`/pages/edit/${this.state.page.id}`} push />
    }
    return <div>
      <CreatePageModal create={this.createPage} {...this.props} {...this.state} />
      <AlertContainer ref={a => (this.msg = a)} {...this.alertOptions} />
    </div>
  }
}

CreatePageModalContainer.propTypes = {
  parentId: PropTypes.number
}

export default CreatePageModalContainer



// WEBPACK FOOTER //
// ./src/components/CreatePageModal/CreatePageModalContainer.js